import React from 'react';
import { PropTypes } from 'prop-types';

/* DEFAULT
 * The breadcrumbs component
 *
 * @param  {string}  items             - array of breadcrumbs
 * @param  {string}  inline            - boolean to add inline class
 * 
 */
export const Breadcrumbs = ({ items, inline, ...attributeOptions }) => {
    return (
        <nav className="au-breadcrumbs " aria-label="Breadcrumb for this page">
            <ul className={`au-link-list ${inline ? ' au-link-list--inline' : ''}`} {...attributeOptions}>
                {
                    items.map(
                        (item, i) => <li key={i} dangerouslySetInnerHTML={{__html: item.link ? "<a href="+ item.link + ">" + item.text + "</a>" : item.text}}></li>
                    )
                }

            </ul>
        </nav>
    )
};

Breadcrumbs.propTypes = {
    items: PropTypes.arrayOf(
        PropTypes.shape({
            link: PropTypes.string,
            text: PropTypes.string.isRequired,
        })
    ).isRequired,
    inline: PropTypes.bool.isRequired
};

Breadcrumbs.defaultProps = {
    items: [],
    inline: true
};

export default Breadcrumbs;